import React from 'react';
import {Platform} from 'react-native';
import BottomExpandableDrawer from '../BottomExpandableDrawer';
import {BUTTON_TYPES} from '../../../utils/Constants';
import {useTheme} from '../../../theme';
import {NoNetworkIcon} from '../../../utils/SvgIcons';

const OfflineNotice = ({visible, onClose, testID}) => {
  const {colors} = useTheme();
  return (
    <BottomExpandableDrawer
      testID={testID}
      visible={visible}
      showRipple
      rippleColor={colors.dangerMuted}
      rippleIcon={<NoNetworkIcon />}
      title="Unable To Connect"
      subtitle="It looks like your device is having trouble connecting to a network. Please check your network settings and try again."
      textAlign={Platform.OS === 'web' ? 'center' : 'left'}
      buttons={[
        {
          title: 'Cancel',
          buttonType: BUTTON_TYPES.Bordered,
          onPress: onClose,
        },
      ]}
    />
  );
};

export default OfflineNotice;
